import { useAuth } from "@/core/auth";
import { usePayrollRosterAccess } from "@/payroll/roster/permissions";

export const useRosterViewer = (businessId: string | null) => {
  const { user } = useAuth();
  const access = usePayrollRosterAccess(businessId);
  return {
    access,
    viewer: { userId: user?.id, visibility: access.data?.roster_visibility },
  };
};
